export default __webpack_public_path__ + "3da65adc05447df5f9bf4af057102aa8.svg";